'use strict'

export default (mockAxios) => {
  mockAxios.onPost(`/merge-persons`).reply(200, {
    'success': false,
    'data': {
      'code': 4221,
      'message': '2人のデータが競合しています。登録する内容を指定してください。',
      'competed': {
        'openflag': {
          '<SID_PERSONS_1>': '0',
          '<SID_PERSONS_2>': '1'
        },
        'twitter_id': {
          '<SID_PERSONS_1>': 'twitter_example_A',
          '<SID_PERSONS_2>': 'twitter_example_B'
        },
        'blog_url': {
          '<SID_PERSONS_1>': 'http://blog.example.A.com',
          '<SID_PERSONS_2>': 'http://blog.example.B.com'
        },
        'memo': {
          '<SID_PERSONS_1>': '猫が好き。',
          '<SID_PERSONS_2>': '猫を飼っている。'
        }
      }
    }
  })

  mockAxios.onPut(new RegExp(`/merge-persons/\\d+`)).reply(200, {
    'success': true
  })

  mockAxios.onPost(`/merge-persons/extraction`).reply(201, {
    'success': true,
    'data': {
      'id': 1
    }
  })
}



// WEBPACK FOOTER //
// ./src/repositories/mock/mergePersonsRepositoryMock.js